exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-heading[data-v-3f49bd1b]{color:#314149!important}[dir] .panel-heading[data-v-3f49bd1b]{border-bottom:2px solid #314149!important}.panel-heading h4[data-v-3f49bd1b]{text-transform:uppercase;font-weight:500}[dir=ltr] .panel-heading h4[data-v-3f49bd1b]{margin-left:-20px;padding-left:10px}[dir=rtl] .panel-heading h4[data-v-3f49bd1b]{margin-right:-20px;padding-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f49bd1b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/user/userProfile.vue
// module id = 831
// module chunks = 0